// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Actions
import { createTaskList } from '../../../../element/taskList/taskListActions';

// Components
import ElementTool from './ElementTool';

const mapDispatchToProps = (dispatch) => ({
    // Creates the task list and an empty task inside the new task list
    customOnDrop: (args) => dispatch(createTaskList(args)),
});

const TaskListTool = ({ currentBoardId, gridSize, currentUserId, permissions, ...rest }) => {
    const elementTypeObject = rest.item?.toolSettings?.elementTypeObject || rest.elementTypeObject || {};
    const selectOnCreate = rest.item?.toolSettings?.selectOnCreate ?? rest.selectOnCreate;
    const editOnCreate = rest.item?.toolSettings?.editOnCreate ?? rest.editOnCreate;

    return (
        <ElementTool
            {...rest}
            toolName={'task-list'}
            className={undefined}
            elementType={elementTypeObject.elementType}
            currentBoardId={currentBoardId}
            currentUserId={currentUserId}
            gridSize={gridSize}
            selectOnCreate={selectOnCreate}
            editOnCreate={editOnCreate}
        />
    );
};

TaskListTool.propTypes = {
    currentBoardId: PropTypes.string.isRequired,
    currentUserId: PropTypes.string.isRequired,
    permissions: PropTypes.number.isRequired,
    gridSize: PropTypes.number.isRequired,
    elementTypeObject: PropTypes.object,
    item: PropTypes.object,
    selectOnCreate: PropTypes.bool,
    customOnDrop: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(TaskListTool);
